import { render, staticRenderFns } from "./ShareDeck.vue?vue&type=template&id=6f0a913c&scoped=true"
import script from "./ShareDeck.vue?vue&type=script&lang=js"
export * from "./ShareDeck.vue?vue&type=script&lang=js"
import style0 from "./ShareDeck.vue?vue&type=style&index=0&id=6f0a913c&prod&scoped=true&lang=less"
import style1 from "./ShareDeck.vue?vue&type=style&index=1&id=6f0a913c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a913c",
  null
  
)

export default component.exports